/* eslint-disable no-unused-vars */
import AskAboutProductModal from "./front/modules/AskAboutProductModal";
import CheckNIP from "./front/modules/CheckNIP";
import CheckNIPMultipleAddress from "./front/modules/CheckNIPMultipleAddress";
import Invoice from "./front/modules/Invoice";
import CheckoutAddresses from "./front/modules/addresses/CheckoutAddresses";
import MyAccountAddresses from "./front/modules/addresses/MyAccountAddresses";
import Wishlist from "./front/modules/Wishlist";
import Compare from "./front/modules/Compare";
import Popup from "./front/modules/Popup";

const askAboutProductModal = new AskAboutProductModal();
const checkNIPField = new CheckNIP();
const initcheckNIPField = new CheckNIPMultipleAddress();
const InvoiceCheckbox = new Invoice();
const FrontCheckoutAddresses = new CheckoutAddresses();
const FrontMyAccountAddresses = new MyAccountAddresses();
const WishlistModule = new Wishlist();
const initCompare = new Compare();
const infoPopup = new Popup();
